const React = require("react");
const noop = require("mn-utils/noop");
const Ripple = require("../../../../../Ripple");
const {default: CancelIcon} = require("@material-ui/icons/Cancel");

const AmountField = ({placeholder, value, onChange}) => {
  return (
    <input
      className={
        `w80 ph16 pv10 f12 ff$3 bgTransparent b0 c959595 olN (cCT|o100):i
        cF.hasValue` + (value ? ' hasValue' : '')
      }
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  )
}


module.exports = ({
  className,
  data,
  onChange = noop,
  ...props
}) => {
  const {
    min_amount: minAmount = '',
    max_amount: maxAmount = '',
  } = data;

  const error = minAmount && maxAmount && Number(minAmount) > Number(maxAmount);
  const valueHandler = (newValue, oldValue) => (
    isNaN(newValue) || newValue < -1 || Number(newValue) > 10 ** 6
      ? oldValue
      : newValue === '0'
        ? newValue
        : Number(newValue)
  )

  return (
    <div
      className={
        `h45 rlv layoutRow jcC aiC bs b1 bcA bg3E4044 r9 bcEC4C4C.error`
        + (error ? ' error' : '')
      }
    >
      <span className="w25 h25 lh16 layoutRow jcC aiC pl25 c959595">
        €
      </span>
      <AmountField
        placeholder="0"
        value={minAmount}
        onChange={(e) => {
          onChange({
            ...props.data,
            min_amount: valueHandler(e.target.value, minAmount)
          })
        }}
      />
      <span>-</span>
      <AmountField
        placeholder="999999"
        value={maxAmount}
        onChange={(e) => {
          onChange({
            ...data,
            max_amount: valueHandler(e.target.value, maxAmount)
          })
        }}
      />
      <div>
        <Ripple
          className={
            `layoutRow fhaC fvaC bg04 w45 h43 r0_9_9_0 dn o50.disabled`
            + (!minAmount && !maxAmount ? ' disabled ' : '')
          }
          onClick={() => onChange && onChange({...props.data, min_amount: '', max_amount: ''})}
          disabled={!minAmount && !maxAmount}
        >
          <CancelIcon className="sq21*2" />
        </Ripple>
      </div>
    </div>
  )
}
